import { SVGProps } from "react"

import { IconProps } from "../nav-icons/icon.types.ts"

export const IconFAQ = ({ hovered, ...props }: IconProps) => {
  if (hovered) return <FAQHover {...props} />
  else return <FAQDefault {...props} />
}

const FAQDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="FAQ_default_svg__Calque_2"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {".FAQ_default_svg__st0{fill:none;stroke:currentColor;stroke-width:2}"}
    </style>
    <path
      className="FAQ_default_svg__st0"
      d="m8.9 19.2 13.2.1c.9 0 1.7-.8 1.7-1.7V6.8c0-1-.8-1.8-1.8-1.8H6c-1.1 0-2 .9-2 2v15.4c0 .2.3.4.4.2l4.5-3.4z"
    />
    <path
      className="FAQ_default_svg__st0"
      d="M24.1 11.2h1.8c.9 0 1.6.8 1.6 1.7v12.9c0 .2-.2.3-.4.2l-3.6-1.4H12.9c-.8 0-1.4-.6-1.4-1.4v-3.5"
    />
    <path
      d="M12.2 9.9s.3-1.3 1.8-1.3c1 0 1.7.8 1.7 1.7 0 .8-.5 1.4-1.2 1.7-.3.1-.6.5-.6.8v.3"
      style={{
        fill: "none",
        stroke: "currentColor",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
    />
    <circle cx={14} cy={15.7} r={0.9} />
  </svg>
)

const FAQHover = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="FAQ_selected_svg__Calque_3"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 32 32"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {".FAQ_selected_svg__st0{fill:none;stroke:currentColor;stroke-width:2}"}
    </style>
    <path
      className="FAQ_selected_svg__st0"
      d="m8.9 19.2 13.2.1c.9 0 1.7-.8 1.7-1.7V6.8c0-1-.8-1.8-1.8-1.8H6c-1.1 0-2 .9-2 2v15.4c0 .2.3.4.4.2l4.5-3.4z"
    />
    <path
      className="FAQ_selected_svg__st0"
      d="M24.1 11.2h1.8c.9 0 1.6.8 1.6 1.7v12.9c0 .2-.2.3-.4.2l-3.6-1.4H12.9c-.8 0-1.4-.6-1.4-1.4v-3.5"
    />
    <path
      fill="currentColor"
      d="M22.1 5H6c-1.1 0-2 .9-2 2v15.4c0 .2.3.4.4.2l4.5-3.4 13.2.1c.9 0 1.7-.8 1.7-1.7V6.8c.1-1-.8-1.8-1.7-1.8zM14 16.6c-.5 0-.9-.4-.9-.9s.4-.9.9-.9.9.4.9.9-.4.9-.9.9zm1.1-3.7v.2c0 .6-.4 1-1 1s-1-.4-1-1v-.3c0-.8.5-1.5 1.2-1.8.3-.1.5-.4.5-.7 0-.4-.3-.7-.7-.7-.6 0-.8.4-.9.6-.2.5-.7.8-1.2.7-.5-.1-.8-.7-.7-1.2.2-.7 1-2 2.8-2 1.5 0 2.7 1.2 2.7 2.7 0 1.1-.7 2.1-1.7 2.5z"
    />
  </svg>
)
